import { UserRoles } from '@dynamika-shared/types/auth';
import { UserMenuIcons } from '@components/UserMenu/UserMenuIcons';
import { CheckMarkIcon, VerticalLogo } from '@dynamika-shared/ui/icons';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';
import { routesPath } from '@router/routes';
import { Link } from 'react-router-dom';
import { useAuthSlice } from '@restore/auth/auth.slice';
import { rolesMap } from 'src/constants/rolesList';

export const SelectRole = () => {
  const [userData, setUserRole] = useAuthSlice((state, actions) => [
    state.data,
    actions.setUserRole,
  ]);

  const handleUserRole = (role: UserRoles) => {
    setUserRole(role);
  };

  return (
    <div className='flex items-center justify-center h-full '>
      <div className='flex flex-col w-[440px] bg-white items-center justify-center rounded-[24px] px-3 py-5 shadow-modalLight '>
        <VerticalLogo className='mb-6 min-h-[92px] min-w-[92px]' />
        <h2 className='text-[24px] leading-[32px] font-semibold text-black'>
          Select Preferred Workspace
        </h2>
        <p className='text-spanishGray text-1824 pt-1 font-medium'>
          Select <span className='text-vividTangelo'>Space</span> you want to
          use{' '}
        </p>

        <div className='w-full max-h-[285px] overflow-x-hidden overflow-y-auto mt-5 pr-2'>
          {userData?.['dynamika7/user_metadata']?.roles.map(
            (role: UserRoles) => {
              if (!rolesMap[role]) {
                return null;
              }
              return (
                <Link to={routesPath.home} key={role}>
                  <div
                    className='border flex rounded-2xl w-[97%] m-1 h-[72px] items-center px-2 group hover:bg-waterLightHover50 cursor-pointer'
                    onClick={() => handleUserRole(role)}
                  >
                    <UserMenuIcons icon={role} />
                    {role === userData?.selectedRole ? (
                      <CheckMarkIcon className='group-hover:text-honoluluBlue w-2 h-2' />
                    ) : (
                      <ChevronIcon className='rotate-180 text-pastelBlue w-2 h-2 group-hover:text-honoluluBlue' />
                    )}
                  </div>
                </Link>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
};
